import { EquipmentColumnKeys } from '../../../../app/pages/resources/equipment/enums/equipment-column-keys.enum';
import { WarningLevel } from '../../../../app/shared/enums/warning-level.enum';
import { ThemeKey } from '../../../theme-key.enum';
import { Theme } from '../../../theme.contract';

export const WACKER_NEUSON_LIGHT: Theme = {
  id: ThemeKey.WACKER_NEUSON_LIGHT,
  icon: 'fa-sun-bright fa-regular fa-fw',
  label: 'EquipCare Light',
  path: 'src/whitelabel/wackerneuson/themes/wacker-neuson-light/theme.scss',
  pathVariables: 'src/whitelabel/wackerneuson/themes/wacker-neuson-light/_variables.scss',
  defaults: {
    columns: {
      equipmentList: [
        EquipmentColumnKeys.IMAGE,
        EquipmentColumnKeys.CUSTOMER_SERIAL_NUMBER,
        EquipmentColumnKeys.SERIAL_NUMBER,
        EquipmentColumnKeys.MODEL,
        EquipmentColumnKeys.MANUFACTURER_NAME,
        EquipmentColumnKeys.TYPE_CATEGORY2,
        EquipmentColumnKeys.CURRENT_ADDRESS,
        EquipmentColumnKeys.STATUS,
        EquipmentColumnKeys.DETAILS,
      ],
    },
  },
  images: {
    noResultsFound: '/assets/images/not-found/no-results-found-light.svg',
    loadingPlaceholder: '/assets/images/loading/loading-placeholder.png',
    logoSmall: 'assets/images/wacker-neuson/logo/Equipcare_Horizontal_logo.svg',
    logoFull: 'assets/images/wacker-neuson/logo/Equipcare_Horizontal.svg',
  },
  chartColors: {
    theme: 'light',
    backgroundColor: undefined,
    defaultChartColors: ['#3c3c3c', '#8dc044', '#ff2230', '#ff7d00'],
    maintenanceSummaryChartColors: {
      [WarningLevel.OVERDUE]: '#d32f2f',
      [WarningLevel.HIGH]: '#C97A20',
      [WarningLevel.MEDIUM]: '#689f38',
      [WarningLevel.LOW]: '#0288d1',
    },
    unselectedLegendItemColor: '#ff0000',
    coreDataChartColors: ['#3c3c3c', '#8dc044'],
    telematicChartColors: ['#3c3c3c', '#8dc044', '#ff2230', '#ff7d00'],
    telematicInsightColors: ['#3c3c3c', '#8dc044', '#ff2230', '#ff7d00', '#ff7563'],
  },
  mapColors: [], // default
  getCategoryIcon: (category: string) => {
    category = category.toUpperCase().replace(/\s+/g, '_');
    const categoryIcons: Record<string, string> = {
      VIBRATORY_RAMMER: '/assets/images/wacker-neuson/stampfer.png',
      PLATE_VIBRATOR: '/assets/images/wacker-neuson/ruettelplatte.png',
      VIBRATORY_ROLLER: '/assets/images/wacker-neuson/grabenwalze.png',
      SAW: '/assets/images/wacker-neuson/versorgungstechnik.png',
      GENERATOR: '/assets/images/wacker-neuson/versorgungstechnik.png',
      TRAILER_MOUNTED_GENERATOR: '/assets/images/wacker-neuson/versorgungstechnik.png',
      LIGHT_TOWER: '/assets/images/wacker-neuson/versorgungstechnik.png',
      WASTE_WATER_PUMP: '/assets/images/wacker-neuson/versorgungstechnik.png',
      DITCH_PUMP: '/assets/images/wacker-neuson/versorgungstechnik.png',
      HEATER: '/assets/images/wacker-neuson/versorgungstechnik.png',
      TRACKED_EXCAVATOR: '/assets/images/wacker-neuson/kettenbagger.png',
      WHEELED_EXCAVATOR: '/assets/images/wacker-neuson/mobilbagger.png',
      WHEEL_LOADER: '/assets/images/wacker-neuson/radlader.png',
      TELESCOPIC_LOADER: '/assets/images/wacker-neuson/teleradlader.png',
      ATTACHMENT: '/assets/images/wacker-neuson/versorgungstechnik.png',
      SKIDSTEER: '/assets/images/wacker-neuson/kompaktlader.png',
      TRACK_LOADER: '/assets/images/wacker-neuson/kompaktkettenlader.png',
      TELEHANDLER: '/assets/images/wacker-neuson/telehandler.png',
      WHEELED_DUMPER: '/assets/images/wacker-neuson/dumper.png',
      TRACKED_DUMPER: '/assets/images/wacker-neuson/kettendumper.png',
      BACKHOE: '/assets/images/wacker-neuson/radlader.png',
      BATTERY: '/assets/images/wacker-neuson/batteryone.png',
      EXCAVATOR: '/assets/images/wacker-neuson/kettenbagger.png',
      DUMPER: '/assets/images/wacker-neuson/dumper.png',
      FORKLIFT: '/assets/images/wacker-neuson/versorgungstechnik.png',
      HARVESTER: '/assets/images/wacker-neuson/versorgungstechnik.png',
      COMPRESSOR: '/assets/images/wacker-neuson/versorgungstechnik.png',
      ROAD_ROLLER: '/assets/images/wacker-neuson/tandemwalze.png',
      OTHER: '/assets/images/wacker-neuson/fallback.png',
      DEFAULT: '/assets/images/wacker-neuson/fallback.png',
    };
    return categoryIcons[category] ?? categoryIcons['DEFAULT'] ?? '';
  },
};
